if(document.querySelector('.simulation-tools') !== null) {

    let currentPage = 1;
    let itemsPerPage = 5;
    let visiblePages = 4;
    let filteredItems = [];

    const searchInput = $('.simulation-tools .search-input');
    const resetButton = $('.simulation-tools input.packages-reset');
    const searchButton = $('.simulation-tools input.packages-search');
    const modelList = $('.simulation-tools .model-list');
    const noResultsMessage = $('#noResultsMessage');

    resetButton.on('click', function(e) {
        e.preventDefault();
        resetFilters();
    })

    searchButton.on('click', function(e) {
        e.preventDefault();
        searchInput.val(normalizeInput(searchInput.val(), false));
        searchByTypeNumber()
    })

    searchInput.on('keyup', function(e) {
        if (e.which === 13 && searchInput.val() !== '') {
            searchButton.click();
        }
    })

    searchInput.on('blur', function (e) {
        searchInput.val(normalizeInput(searchInput.val(), false));
    })


    const getProductDocumentsData = function(attrs) {
        filteredItems = [];
        modelList.empty();
        $.ajax({
            url: `${window.location.origin + ctxPath}/.rest/product/v1/product-documents`,
            method: 'GET',
            dataType: 'json',
            data: attrs,
            headers: {
                'Accept': 'application/json'
            },
            timeout: 10000
        })
        .done(function(data, textStatus, xhr) {
            if (xhr.status === 204 || !data || !data.items || data.items.length === 0) {
                noResultsMessage.show();
                $('.results-container').hide();
                $('.pagination').hide();
                modelList.hide();
                return;
            }

            data.items.forEach(function(item) {
                let html = `<div class="model-item"><span class="type-number"><a href="/pip/${item.productTypeNumber}" target="_blank">${item.productTypeNumber}</a></span>`;

                if (item.simulationModels) {
                    item.simulationModels.forEach(function(doc) {
                        const tagClass = doc.simulationTag ? `model-tag-${doc.simulationTag}` : '';
                        html += `<span class="model-tag ${tagClass}"><a href="${doc.link}" target="_blank">${doc.simulationTag  
                        ? doc.simulationTag : doc.name}</a></span>`;
                    });
                }

                if (item.sparameters) {
                    item.sparameters.forEach(function(doc) {
                        html += `<span class="model-tag model-tag-s-parameters"><a href="${doc.link}" target="_blank">${doc.simulationTag ? doc.simulationTag : doc.name}</a></span>`;
                    });
                }

                html += '</div>';
                modelList.append(html);
            });

            paginateItems();
        })
        .fail(function(xhr, textStatus, errorThrown) {
            console.error('ERROR', xhr.status, xhr.responseText || errorThrown);
        });
    };

    function paginateItems() {
        const modelItems = document.querySelectorAll('.model-item');
        const items = filteredItems.length || document.getElementById('searchInput').value.trim()
            ? filteredItems
            : modelItems;
        const totalPages = Math.ceil(items.length / itemsPerPage);
        const pagination = document.querySelector('.pagination');

        pagination.innerHTML = '';

        const prevChunk = document.createElement('li');
        prevChunk.classList.add('VuePagination__pagination-item', 'page-item', 'VuePagination__pagination-item-prev-chunk');
        prevChunk.innerHTML = `<a href="javascript:void(0);" class="page-link ${currentPage <= 1 ? 'disabled' : ''}" onclick="gotoChunk(-1)">&laquo;</a>`;
        pagination.appendChild(prevChunk);

        const prevPage = document.createElement('li');
        prevPage.classList.add('VuePagination__pagination-item', 'page-item', 'VuePagination__pagination-item-prev-page');
        prevPage.innerHTML = `<a href="javascript:void(0);" class="page-link ${currentPage <= 1 ? 'disabled' : ''}" onclick="gotoPage(${currentPage - 1})">&lsaquo;</a>`;
        pagination.appendChild(prevPage);

        const startPage = Math.floor((currentPage - 1) / visiblePages) * visiblePages + 1;
        const endPage = Math.min(startPage + visiblePages - 1, totalPages);

        for (let i = startPage; i <= endPage; i++) {
            const pageItem = document.createElement('li');
            pageItem.classList.add('VuePagination__pagination-item', 'page-item');
            if (i === currentPage) {
                pageItem.innerHTML = `<a href="javascript:void(0)" class="page-link active">${i}</a>`;
            } else {
                pageItem.innerHTML = `<a href="javascript:void(0)" class="page-link" onclick="gotoPage(${i})">${i}</a>`;
            }
            pagination.appendChild(pageItem);
        }

        const nextPage = document.createElement('li');
        nextPage.classList.add('VuePagination__pagination-item', 'page-item', 'VuePagination__pagination-item-next-page');
        nextPage.innerHTML = `<a href="javascript:void(0);" class="page-link ${currentPage >= totalPages ? 'disabled' : ''}" onclick="gotoPage(${currentPage + 1})">&rsaquo;</a>`;
        pagination.appendChild(nextPage);

        const nextChunk = document.createElement('li');
        nextChunk.classList.add('VuePagination__pagination-item', 'page-item', 'VuePagination__pagination-item-next-chunk');
        nextChunk.innerHTML = `<a href="javascript:void(0);" class="page-link ${currentPage >= totalPages ? 'disabled' : ''}" onclick="gotoChunk(1)">&raquo;</a>`;
        pagination.appendChild(nextChunk);

        items.forEach((item, index) => {
            if (index >= (currentPage - 1) * itemsPerPage && index < currentPage * itemsPerPage) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });

        const hasItems = items.length > 0;
        document.getElementById('noResultsMessage').style.display = hasItems ? 'none' : 'block';
        document.querySelector('.results-container').style.display = hasItems ? 'flex' : 'none';
        document.querySelector('.pagination').style.display = hasItems ? 'flex' : 'none';
        document.querySelector('.model-list').style.display = hasItems ? 'block' : 'none';

        updateResultsCount(items.length);
    }

    function gotoPage(page) {
        currentPage = page;
        paginateItems();
    }

    function gotoChunk(direction) {
        const modelItems = document.querySelectorAll('.model-item');
        const items = filteredItems.length ? filteredItems : modelItems;
        const totalPages = Math.ceil(items.length / itemsPerPage);
        const newPage = currentPage + (visiblePages * direction);
        currentPage = Math.min(Math.max(newPage, 1), totalPages);
        paginateItems();
    }

    function searchByTypeNumber() {
        const input = document.getElementById('searchInput').value.trim().toUpperCase();
        const modelItems = document.querySelectorAll('.model-item');
        filteredItems = [];

        modelItems.forEach(item => {
            const modelName = item.querySelector('.type-number a').textContent.toUpperCase();
            const shouldDisplay = modelName.includes(input);
            item.style.display = shouldDisplay ? 'block' : 'none';
            if (shouldDisplay) {
                filteredItems.push(item);
            }
        });

        resetPagination();
    }

    function resetFilters() {
        document.getElementById('searchInput').value = '';
        getProductDocumentsData();
    }

    function resetPagination() {
        currentPage = 1;
        paginateItems();
    }

    function updateItemsPerPage() {
        itemsPerPage = parseInt(document.getElementById('itemsPerPageSelect').value);
        resetPagination();
    }

    function updateResultsCount(totalItems) {
        const startItem = (currentPage - 1) * itemsPerPage + 1;
        const endItem = Math.min(currentPage * itemsPerPage, totalItems);
        const resultsCount = document.querySelector('.results-count');
        resultsCount.textContent = `Showing results ${startItem} to ${endItem} of ${totalItems}`;
    }

    document.addEventListener('DOMContentLoaded', () => {
        getProductDocumentsData();
    });
}